import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29ba70d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "W-100 MobileEnlarger",
  style: {"overflow-y":"scroll"}
}
const _hoisted_2 = {
  class: "W-100 CookiesGeneralTable",
  CELLSPACING: "0"
}
const _hoisted_3 = {
  key: 0,
  class: "CookiesFade"
}
const _hoisted_4 = {
  colspan: "20",
  style: {"padding":"1.5em 0.2em"}
}
const _hoisted_5 = ["Tooltip", "href", "onClick"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["Tooltip", "onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["Tooltip", "onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["Tooltip", "onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["Tooltip"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { style: {"display":"block","margin-top":"-1em","margin-bottom":"-0.75em","padding-top":"0.5em"} }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["Tooltip"]
const _hoisted_21 = ["onClick", "href"]
const _hoisted_22 = {
  key: 0,
  class: "W-100 MultiField"
}
const _hoisted_23 = { class: "GeneralField F_85em" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["Tooltip", "onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["href"]
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "CookiesTablePager" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "D-Flex" }
const _hoisted_33 = { class: "M-Auto D-Flex P-Rel" }
const _hoisted_34 = {
  key: 1,
  class: "F1_25em M-Auto Transition0_25",
  style: {"padding":"0 1em"}
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 2,
  class: "F1_25em M-Auto Transition0_25",
  style: {"padding":"0 1em"}
}
const _hoisted_37 = { class: "OrdersNumber D-Flex" }
const _hoisted_38 = { class: "M-Auto F-Bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesSortingTH = _resolveComponent("CookiesSortingTH")!
  const _component_CookiesFunctionalTableGeneralField = _resolveComponent("CookiesFunctionalTableGeneralField")!
  const _component_vue_barcode = _resolveComponent("vue-barcode")!
  const _component_vueQr = _resolveComponent("vueQr")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesBar = _resolveComponent("CookiesBar")!
  const _component_CookiesTimeLineTable = _resolveComponent("CookiesTimeLineTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TableSettings.Fields, (Field) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: (Field as FunctionalTableField)
          }, [
            (Field.Visible === undefined || Field.Visible)
              ? (_openBlock(), _createBlock(_component_CookiesSortingTH, {
                  key: 0,
                  Sortable: Field.Sort !== undefined,
                  onClick: ($event: any) => (Field.Sort && _ctx.SortTable(Field.Sort, 'SortElement')),
                  Name: _ctx.Translate(Field.Name ? Field.Name : ''),
                  Value: Field.Sort,
                  SearchRes: Field.IsSearchable ? 'TableFieldSearch_' + Field.Name : undefined,
                  sortColumn: _ctx.SortElement
                }, null, 8, ["Sortable", "onClick", "Name", "Value", "SearchRes", "sortColumn"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      (_ctx.Loading.length === 0 && _ctx.CookiesData.length === 0)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.Translate('No Data')), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PageData, (item, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: item.ID,
          class: "CookiesGeneralTableRow CookiesFade"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TableSettings.Fields, (Field) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: (Field as FunctionalTableField)
            }, [
              ((Field.Visible === undefined || Field.Visible))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (Field.Type === 'Index')
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 0,
                          class: _normalizeClass(["P1em", Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')]),
                          style: _normalizeStyle(Field.Style)
                        }, _toDisplayString(index + 1), 7))
                      : (Field.Type === 'Normal' || Field.Type === undefined)
                        ? (_openBlock(), _createBlock(_component_CookiesFunctionalTableGeneralField, {
                            key: 1,
                            onContentClicked: ($event: any) => (Field.Emits && _ctx.$emit(Field.Emits, item)),
                            Field: Field,
                            item: item
                          }, null, 8, ["onContentClicked", "Field", "item"]))
                        : (Field.Type === 'Image')
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 2,
                              class: _normalizeClass(Field.Class  + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                              style: _normalizeStyle(Field.Style)
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["SQR2_5em TableImage", Field.ImageClass]),
                                Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip,
                                href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                target: "_blank",
                                onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : ''),
                                style: _normalizeStyle([Field.ImageStyle ? Field.ImageStyle : '', 'background-image: url(' + _ctx.DefaultImageHandler(Field.Path ? _ctx.DeepFetcher(item, Field.Path) : undefined, Field.ImageDefault) + ')'])
                              }, null, 14, _hoisted_5)
                            ], 6))
                          : (Field.Type === 'DateTime')
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 3,
                                href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                target: "_blank",
                                class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '') + (Field.DueDate && Field.Path ? _ctx.CompareDates(_ctx.DeepFetcher(item, Field.Path), new Date()) === 0 ? ' colorFourth ' : _ctx.CompareDates(_ctx.DeepFetcher(item, Field.Path), new Date()) === 2 ? ' colorr1 ' : '' : '')),
                                style: _normalizeStyle(Field.Style)
                              }, [
                                _createElementVNode("span", {
                                  Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip,
                                  onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : '')
                                }, [
                                  _createTextVNode(_toDisplayString(Field.Path && _ctx.DateFormatter(_ctx.DeepFetcher(item, Field.Path), Field.DateStyle)) + " ", 1),
                                  (Field.Quantity)
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString('X') + " " + _toDisplayString(_ctx.DeepFetcher(item, Field.Quantity)), 1))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_7)
                              ], 14, _hoisted_6))
                            : (Field.Type === 'Time')
                              ? (_openBlock(), _createElementBlock("td", {
                                  key: 4,
                                  href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                  target: "_blank",
                                  class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                  style: _normalizeStyle(Field.Style)
                                }, [
                                  _createElementVNode("span", {
                                    Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip,
                                    onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : '')
                                  }, [
                                    _createTextVNode(_toDisplayString(Field.Path && _ctx.TimeFormatter(_ctx.DeepFetcher(item, Field.Path))) + " ", 1),
                                    (Field.Quantity)
                                      ? (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString('X') + " " + _toDisplayString(_ctx.DeepFetcher(item, Field.Quantity)), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_10)
                                ], 14, _hoisted_9))
                              : (Field.Type === 'Calendar')
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 5,
                                    href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                    target: "_blank",
                                    class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                    style: _normalizeStyle(Field.Style)
                                  }, [
                                    _createElementVNode("span", {
                                      Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip,
                                      onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : '')
                                    }, [
                                      _createTextVNode(_toDisplayString(Field.Path && _ctx.CalendarFormatter(_ctx.DeepFetcher(item, Field.Path))) + " ", 1),
                                      (Field.Quantity)
                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_14, _toDisplayString('X') + " " + _toDisplayString(_ctx.DeepFetcher(item, Field.Quantity)), 1))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_13)
                                  ], 14, _hoisted_12))
                                : (Field.Type === 'Barcode')
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 6,
                                      href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                      target: "_blank",
                                      class: _normalizeClass(Field.Class + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                      style: _normalizeStyle(Field.Style)
                                    }, [
                                      (Field.Path && Field.Path !== '' && Field.Path !== null)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            style: {"background":"white","border-radius":"var(--rad3)","display":"inline-block","padding-bottom":"0.75em","color":"black"},
                                            Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip
                                          }, [
                                            _createVNode(_component_vue_barcode, {
                                              onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : ''),
                                              style: {"width":"10em","height":"3em"},
                                              value: _ctx.DeepFetcher(item, Field.Path),
                                              options: { displayValue: false, fontSize: 10, background: 'rgba(0,0,0,0)'}
                                            }, null, 8, ["onClick", "value", "options"]),
                                            _hoisted_17,
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.DeepFetcher(item, Field.Path)), 1)
                                          ], 8, _hoisted_16))
                                        : _createCommentVNode("", true)
                                    ], 14, _hoisted_15))
                                  : (Field.Type === 'QR')
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 7,
                                        href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                        target: "_blank",
                                        class: _normalizeClass(Field.Class + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                        style: _normalizeStyle(Field.Style)
                                      }, [
                                        (Field.Path && Field.Path !== '' && Field.Path !== null)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip
                                            }, [
                                              _createVNode(_component_vueQr, {
                                                callback: _ctx.SaveQRDataURI,
                                                qid: Field.QRID ? _ctx.DeepFetcher(item, Field.QRID): undefined,
                                                style: _normalizeStyle([{"width":"3em","height":"3em"}, Field.QRStyle]),
                                                text: _ctx.DeepFetcher(item, Field.Path),
                                                class: "Rad1 M-Auto",
                                                size: Field.QRSize ? Field.QRSize : 800
                                              }, null, 8, ["callback", "qid", "style", "text", "size"])
                                            ], 8, _hoisted_20))
                                          : _createCommentVNode("", true)
                                      ], 14, _hoisted_19))
                                    : (Field.Type === 'Multi')
                                      ? (_openBlock(), _createElementBlock("td", {
                                          key: 8,
                                          onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : ''),
                                          href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                          target: "_blank",
                                          class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                          style: _normalizeStyle(Field.Style)
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MultiFieldsCap(item, Field), (MultiItem, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "W-100 MultiField",
                                              key: (MultiItem as any, i)
                                            }, [
                                              _createVNode(_component_CookiesFunctionalTableGeneralField, {
                                                Field: Field.MultiFields,
                                                item: MultiItem
                                              }, null, 8, ["Field", "item"])
                                            ]))
                                          }), 128)),
                                          (Field.Path && _ctx.DeepFetcher(item, Field.Path).length > 5)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                _createElementVNode("td", _hoisted_23, "+(" + _toDisplayString(_ctx.DeepFetcher(item, Field.Path).length-5) + ")", 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 14, _hoisted_21))
                                      : (Field.Type === 'StatusBox')
                                        ? (_openBlock(), _createElementBlock("td", {
                                            key: 9,
                                            href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                            target: "_blank",
                                            class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                            style: _normalizeStyle(Field.Style)
                                          }, [
                                            (Field.Path)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  Tooltip: Field.DynamicToolTip ? _ctx.DeepFetcher(item, Field.DynamicToolTip) : Field.ToolTip,
                                                  style: _normalizeStyle([{"padding":"0.5em","border-radius":"var(--rad2)","color":"#010101","white-space":"nowrap"}, [Field.StatusStyleColors ? 'background-color: ' + Field.StatusStyleColors[_ctx.DeepFetcher(item, Field.Path)] : '', Field.StatusStyle ? Field.StatusStyle : '']]),
                                                  onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : ''),
                                                  class: _normalizeClass([Field.StatusClassColors ? Field.StatusClassColors[_ctx.DeepFetcher(item, Field.Path)] : '', Field.StatusClass ? Field.StatusClass : ''])
                                                }, _toDisplayString(_ctx.Translate(_ctx.DeepFetcher(item, Field.Path))), 15, _hoisted_25))
                                              : _createCommentVNode("", true)
                                          ], 14, _hoisted_24))
                                        : (Field.Type === 'ActionIcons')
                                          ? (_openBlock(), _createElementBlock("td", {
                                              key: 10,
                                              onClick: ($event: any) => (Field.Emits ? _ctx.$emit(Field.Emits, item) : Field.Whatsapp ? _ctx.OpenWhatsapp(_ctx.DeepFetcher(item, Field.Whatsapp)) : ''),
                                              class: _normalizeClass(Field.Class ? Field.Class : '' + ' ' + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                              style: _normalizeStyle((Field.ActionIcons ? ('width: ' + (Field.ActionIcons.length * 2) + 'em;') : '') + ' ' + Field.Style)
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Field.ActionIcons, (Icon) => {
                                                return (_openBlock(), _createElementBlock("a", {
                                                  key: (Icon),
                                                  href: Icon.Link && _ctx.DeepFetcher(item, Icon.Link),
                                                  target: "_blank",
                                                  style: {"white-space":"nowrap"}
                                                }, [
                                                  ((Icon.Visible === undefined || Icon.Visible) && _ctx.DynamicCalculator(item, Icon, 'DynamicVisiblity'))
                                                    ? (_openBlock(), _createBlock(_component_CookiesIcon, {
                                                        key: 0,
                                                        onClick: ($event: any) => (Icon.Emits && _ctx.$emit(Icon.Emits, item)),
                                                        Tooltip: Icon.DynamicToolTip ? _ctx.DeepFetcher(item, Icon.DynamicToolTip) : Icon.ToolTip ? _ctx.Translate(Icon.ToolTip) : '',
                                                        class: "CookiesRowIcon HoverUp",
                                                        style: {"padding-top":"0.2em","padding-bottom":"0.2em"},
                                                        Color: Icon.Color,
                                                        IconsSheet: Icon.IconsSheet,
                                                        ID: Icon.ID,
                                                        Style: Icon.Style
                                                      }, null, 8, ["onClick", "Tooltip", "Color", "IconsSheet", "ID", "Style"]))
                                                    : _createCommentVNode("", true)
                                                ], 8, _hoisted_27))
                                              }), 128))
                                            ], 14, _hoisted_26))
                                          : (Field.Type === 'Bar')
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 11,
                                                href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                                target: "_blank",
                                                class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                                style: _normalizeStyle(Field.Style)
                                              }, [
                                                _createVNode(_component_CookiesBar, {
                                                  Bar: { Min: Field.BarMinPath ? _ctx.DeepFetcher(item, Field.BarMinPath) : Field.BarMinFixed ? Field.BarMinFixed : 0, Max: Field.BarMaxPath ? _ctx.DeepFetcher(item, Field.BarMaxPath) : Field.BarMaxFixed ? Field.BarMaxFixed : 0, Values: _ctx.BarValues(item, Field) }
                                                }, null, 8, ["Bar"])
                                              ], 14, _hoisted_28))
                                            : (Field.Type === 'Slot')
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 12,
                                                  href: Field.Link && _ctx.DeepFetcher(item, Field.Link),
                                                  target: "_blank",
                                                  class: _normalizeClass(Field.Class + (Field.Bold ? ' F-Bold ': '') + (Field.DataClass ? ' ' + _ctx.DeepFetcher(item, Field.DataClass): '') + ' ' + ((Field.DynamicClass && _ctx.DynamicCalculator(item, Field, 'DynamicClass')) ? Field.DynamicClass.ClassList: '')),
                                                  style: _normalizeStyle(Field.Style)
                                                }, [
                                                  _renderSlot(_ctx.$slots, "default", {
                                                    Field: Field,
                                                    item: item
                                                  }, undefined, true)
                                                ], 14, _hoisted_29))
                                              : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.TableSettings.TimeLine)
            ? (_openBlock(), _createBlock(_component_CookiesTimeLineTable, {
                key: 0,
                class: "OrderTimeLine",
                TimeLinesHistory: _ctx.DeepFetcher(item, _ctx.TableSettings.TimeLine?.Path)
              }, null, 8, ["TimeLinesHistory"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_30, [
      (_ctx.SortedData.length > _ctx.DataPerPage && _ctx.PageData.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_CookiesIcon, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CurrentPage > 1 ? _ctx.ChangePage(_ctx.CurrentPage - 1) : '')),
                class: "P-Rel HoverGlow",
                style: {"width":"1em","height":"1em","transform":"rotate(90deg)","margin":"auto 2em","float":"left"},
                ID: 'SortingArrow'
              }),
              _createElementVNode("div", _hoisted_33, [
                (_ctx.CurrentPage > 3)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CurrentPage !== 1 ? _ctx.ChangePage(1) : '')),
                      class: "F1_25em M-Auto Transition0_25 HoverGlow",
                      style: {"padding":"0 1em"}
                    }, "1"))
                  : _createCommentVNode("", true),
                (_ctx.CurrentPage > 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "..."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage), (PageNum) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: PageNum }, [
                    (Math.abs(_ctx.CurrentPage - PageNum) < 3)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.ChangePage(PageNum)),
                          class: _normalizeClass([_ctx.CurrentPage === PageNum && 'CurrentPage F-Bold', "F1_25em M-Auto HoverGlow Transition0_25"]),
                          style: {"padding":"0 1em"}
                        }, _toDisplayString(PageNum), 11, _hoisted_35))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                (Math.abs(_ctx.CurrentPage - Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage)) >= 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, "..."))
                  : _createCommentVNode("", true),
                (Math.abs(_ctx.CurrentPage - Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage)) >= 3)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CurrentPage !== Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage) ? _ctx.ChangePage(Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage)) : '')),
                      class: "F1_25em M-Auto Transition0_25 HoverGlow",
                      style: {"padding":"0 1em"}
                    }, _toDisplayString(Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_CookiesIcon, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.CurrentPage < Math.ceil(_ctx.SortedData.length / _ctx.DataPerPage) ? _ctx.ChangePage(_ctx.CurrentPage + 1) : '')),
                class: "P-Rel HoverGlow",
                style: {"width":"1em","height":"1em","transform":"rotate(-90deg)","margin":"auto 2em"},
                ID: 'SortingArrow'
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.SortedData.length), 1)
      ])
    ])
  ]))
}